// extracted by mini-css-extract-plugin
export default {"thresholdValueContainer":"ThresholdValue_thresholdValueContainer__5CLBd","title":"ThresholdValue_title__0wABj"};